<template>
  <div>
    <div>
      <el-input placeholder="输入报告名称" style="width: 220px;float: left" v-model="formParam.recipient"></el-input>
      <el-button type="info" plain style="margin-left: 10px;float: left" @click="handleSearch">搜索</el-button>
      <el-button type="primary" plain style="float: right;" @click="handleAdd">新增</el-button>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%">
      <el-table-column
        prop="recipient"
        label="收件人"
        width="80">
      </el-table-column>
      <el-table-column
        prop="mobile"
        label="手机号码"
        width="120">
      </el-table-column>
      <el-table-column
        prop="area"
        width="220"
        label="所在地区">
      </el-table-column>
      <el-table-column
        prop="addressDetail"
        label="详细地址">
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="140">
        <template slot-scope="scope">
          <el-radio :label="scope.row.id" v-model="templateRadio"
                    @change.native="getTemplateRow(scope.$index,scope.row)">选择
          </el-radio>
        </template>
      </el-table-column>
    </el-table>
    <pagination v-bind:child-msg="pageParam" @callFather="callFather"></pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" v-if="editFormVisible" :destroy-on-close="true"
               width="70%" @click="closeDialog" center
               :close-on-click-modal="false"
               :close-on-press-escape="false" append-to-body>
      <address-edit ref="editDialog" :edit="editForm"></address-edit>
      <div slot="footer" class="dialog-footer" v-if="editForm.pageType !== 'view'">
        <el-button type="primary" :loading="loading" class="title" @click="handleSave">保存</el-button>
        <el-button @click="closeDialog">取消</el-button>
      </div>
      <div slot="footer" class="dialog-footer" v-if="editForm.pageType === 'view'">
        <el-button @click="closeDialog">返回</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { list, save, edit, deletk } from '@/api/user/userAddress'
import addressEdit from './edit/addressEdit.vue'
export default {
  components: { addressEdit },
  name: 'myAddress',
  data () {
    return {
      title: '',
      tableData: [],
      editFormVisible: false,
      templateRadio: '1',
      isDisabled: false,
      selectAddress: {},
      pageParam: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      formParam: {},
      editForm: {}
    }
  },
  computed: {
    user () {
      return this.$store.state.user.userInfo
    },
    companyInfo () {
      return this.$store.state.user.companyInfo
    },
    isLogin () {
      return this.$store.state.user.isLogin
    }
  },
  created () {
    this.handleSearch()
  },
  methods: {
    getTemplateRow (index, row) {
      this.templateSelection = row
      this.tableData.forEach((row, index) => {
        row.enableFlag = this.templateSelection.id
      })
      row.enableFlag = 1
      this.selectAddress.toAddress = this.templateSelection.province + ' ' + this.templateSelection.city + ' ' +
        this.templateSelection.area + ' ' + this.templateSelection.addressDetail
      this.selectAddress.toMobile = this.templateSelection.mobile
      this.selectAddress.toAddressee = this.templateSelection.recipient
    },
    handleSearch () {
      this.formParam.page = {
        pageNum: this.pageParam.currentPage,
        pageSize: this.pageParam.pageSize,
        orderBy: 'createTime'
      }
      this.mockTableData()
    },
    mockTableData () {
      list(this.formParam).then(res => {
        this.loading = false
        var result = res.data
        if (result.rtnCode !== '0') {
          this.$message({
            type: 'info',
            message: result.msg
          })
        } else {
          this.tableData = result.bizData
          this.pageParam.total = result.total
          if (this.tableData && this.tableData.length > 0) {
            this.templateRadio = this.tableData[0].id
            this.selectAddress.toAddress = this.tableData[0].province + ' ' + this.tableData[0].city + ' ' +
              this.tableData[0].area + ' ' + this.tableData[0].addressDetail
            this.selectAddress.toMobile = this.tableData[0].mobile
            this.selectAddress.toAddressee = this.tableData[0].recipient
          }
        }
      }).catch(ex => {
        this.loading = false
        this.$message.error('列表加载失败，请稍后再试！')
      })
    },
    // 新增
    handleAdd () {
      this.title = '新增收货地址'
      this.editForm = {}
      if (this.user.name) {
        this.editForm.recipient = this.user.name
      }
      if (this.user.mobile) {
        this.editForm.mobile = this.user.mobile
      }
      this.editForm.isDefault = 1
      this.editForm.pageType = 'add'
      this.editFormVisible = true
    },
    handleEdit (row) {
      this.title = '编辑收货地址'
      this.editForm.id = row.id
      this.editForm.recipient = row.recipient
      this.editForm.mobile = row.mobile
      this.editForm.province = row.province
      this.editForm.city = row.city
      this.editForm.area = row.area
      this.editForm.addressDetail = row.addressDetail
      if (row.isDefault !== null) {
        this.editForm.isDefault = Number(row.isDefault)
      }
      this.editForm.pageType = 'edit'
      this.editFormVisible = true
    },
    handleView (row) {
      this.title = '查看收货地址'
      this.editForm.id = row.id
      this.editForm.recipient = row.recipient
      this.editForm.mobile = row.mobile
      this.editForm.province = row.province
      this.editForm.city = row.city
      this.editForm.area = row.area
      this.editForm.addressDetail = row.addressDetail
      if (row.isDefault !== null) {
        this.editForm.isDefault = Number(row.isDefault)
      }
      this.editForm.pageType = 'view'
      this.editFormVisible = true
    },
    // 删除
    handleDelete (row) {
      var del = confirm('是否要删除选中数据?')
      if (del === true) {
        this.editForm.id = row.id
        var params = { ids: [] }
        params.ids.push(this.editForm.id)
        deletk(params).then(res => {
          this.loading = false
          var result = res.data
          if (result.rtnCode !== '0') {
            this.$message({
              type: 'info',
              message: result.msg
            })
          } else {
            this.handleSearch()
          }
        }).catch(ex => {
          this.loading = false
          this.$message.error('删除收货地址失败，请稍后再试！')
        })
      } else {
        return false
      }
    },
    // 保存
    handleSave () {
      if (this.isDisabled) {
        return false
      }
      this.isDisabled = true
      const formBody = this.$refs['editDialog'].editForm
      formBody.companyId = this.user.companyId
      this.$refs['editDialog'].$refs['editForm'].validate(valid => {
        if (valid) {
          if (typeof (formBody.province) === 'undefined' || typeof (formBody.city) === 'undefined' || typeof (formBody.area) === 'undefined') {
            this.$message.warning('请选择完整的地址')
            this.isDisabled = false
            return false
          }
          if (formBody.pageType === 'edit') {
            this.isDisabled = false
            edit(formBody).then(response => {
              this.isDisabled = false
              const result = response.data
              if (result.rtnCode === '0') {
                this.editFormVisible = false
                this.handleSearch()
              } else {
                this.loading = false
                this.$message({
                  type: 'info',
                  message: '修改失败，' + result.msg
                })
              }
            }).catch(ex => {
              this.isDisabled = false
              this.loading = false
              this.$message('修改收货地址失败，请稍后再试！')
            })
          } else if (formBody.pageType === 'add') {
            save(formBody).then(response => {
              this.isDisabled = false
              const result = response.data
              if (result.rtnCode === '0') {
                this.editFormVisible = false
                this.handleSearch()
              } else {
                this.loading = false
                this.$message({
                  type: 'info',
                  message: '新增收货地址失败，' + result.msg
                })
              }
            }).catch(ex => {
              this.isDisabled = false
              this.loading = false
              this.$message('新增收货地址失败，请稍后再试！')
            })
          }
        } else {
          this.isDisabled = false
          return false
        }
      })
    },
    // 分页插件事件
    callFather (parm) {
      this.pageParam.currentPage = parm.currentPage
      this.pageParam.pageSize = parm.pageSize
      this.handleSearch()
    },
    closeDialog () {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>

</style>
